export enum StageState {
    Scheduled = 1,
    Running = 2,
    Canceled = 3,
    Error = 4,
    Done = 5,
};